module.exports = __webpack_public_path__ + "assets/img/portfolio-solar.0391609f.jpg";